if (!customElements.get('custom-reviews-slider')) {
  class CustomReviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.perView = 1;
      this.pages = this.slides.length;
      this.activePage = 0;
      this.isScrolling = false;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goToPage(Number(dot.dataset.index)));
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goToPage(this.activePage - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goToPage(this.activePage + 1));

      if (this.track) {
        this.track.addEventListener(
          'scroll',
          () => {
            window.clearTimeout(this.scrollTimeout);
            this.scrollTimeout = window.setTimeout(() => this.onScrollSettled(), 100);
          },
          { passive: true }
        );
      }

      window.addEventListener('resize', () => this.updateLayout());
      this.updateLayout();
    }

    updateLayout() {
      if (!this.track || !this.slides.length) return;
      const trackWidth = this.track.getBoundingClientRect().width;
      const firstWidth = this.slides[0].getBoundingClientRect().width;
      this.perView = Math.max(1, Math.round(trackWidth / firstWidth));
      this.pages = Math.max(1, Math.ceil(this.slides.length / this.perView));

      this.dots.forEach((dot, i) => {
        dot.hidden = i >= this.pages;
      });

      this.setActivePage(Math.min(this.activePage, this.pages - 1));
    }

    onScrollSettled() {
      if (!this.track || !this.slides.length) return;
      const firstWidth = this.slides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = (firstWidth + gap) * this.perView;
      const page = step ? Math.round(this.track.scrollLeft / step) : 0;
      this.setActivePage(page);
    }

    goToPage(page) {
      const clamped = Math.max(0, Math.min(page, this.pages - 1));
      const slide = this.slides[clamped * this.perView];
      if (!slide || !this.track) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      this.setActivePage(clamped);
    }

    setActivePage(page) {
      this.activePage = page;
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === page));
      if (this.prevBtn) this.prevBtn.disabled = page === 0;
      if (this.nextBtn) this.nextBtn.disabled = page === this.pages - 1;
    }
  }

  customElements.define('custom-reviews-slider', CustomReviewsSlider);
}
